import { defineStore } from "pinia";
import { ref } from "vue";

export const useToastsStore = defineStore("toasts", () => {
  const toasts = ref([]);

  function create(toast) {
    toast = { ...toast, id: Date.now() };
    toasts.value.push(toast);
    setTimeout(() => remove(toast.id), toast.duration || 10000);
  }

  function info(options) {
    create({ ...options, type: "info" });
  }

  function success(options) {
    create({ ...options, type: "success" });
  }

  function error(options) {
    create({ ...options, type: "error" });
  }

  function remove(id) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  return { toasts, info, success, error, remove };
});
